const locale = 'fr-FR'

const formatPrice = (price) => {
 return price ? parseFloat(price).toLocaleString(locale, {style: "currency", currency: "EUR"}) : ''
}

const formatPriceWithoutDecimals = (price) => {
    return price ? parseFloat(price).toLocaleString(locale, {style: "currency", currency: "EUR", maximumFractionDigits: 0}) : ''
}

export {
    formatPrice,
    formatPriceWithoutDecimals
}
